export { default as StaticAnalysisInsightsCard } from "./StaticAnalysisInsightsCard";
